import Bugsnag from "@bugsnag/js";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { lenderResourceShareService } from "@/modules/contacts/features/lender/store/resource-share-services/lender-resource-share-service";

const previewResourceShare = lenderResourceShareService.injectEndpoints({
  endpoints: builder => ({
    previewResourceShare: builder.mutation({
      query: ({ lenderId, resourceShareId }) => ({
        url: `lenders/${lenderId}/resource-shares/${resourceShareId}/preview`,
        method: "GET",
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          const a = document.createElement("a");
          a.style.display = "none";
          a.href = data.url;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          sendAnalytics(ANALYTIC_EVENTS.RESOURCE_SHARE_PREVIEWED, data.file);
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { usePreviewResourceShareMutation } = previewResourceShare;

